import React, { Component } from "react";
import GoogleMapReact from "google-map-react";

import swal from "@sweetalert/with-react";
import swalAlert from "sweetalert";
import { DataService } from "../services/data.service";

import { Empty } from "antd";

import Bowser from "bowser";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import Loader from "../components/loader/loader";
import * as handler from "../components/utils/handler";
const queryString = require("query-string");

const queryStringBranchCode = queryString.parse(window.location.search)
  .branchCode;

const Loading = () => <Loader />;

class BranchSelection extends Component {
  dataService = new DataService();
  defaultLanguage = window["app-config"].defaultLang;
  mapCenter = window["app-config"].mapCenter;
  mapZoom = window["app-config"].mapZoom;
  issueTicketEnabled = window["app-config"].issueTicketEnabled;
  issueAppointmentEnabled = window["app-config"].issueAppointmentEnabled;
  enableCategorySelection = window["app-config"].enableCategorySelection;
  color = window["app-config"].ui.branchMapScreen;
  alertColor = window["app-config"].ui.branchMapScreen.alertBtnColor;
  apiKey = window["app-config"].mapApiKey;
  runApp = window["app-config"].runApp;
  pinMarker = window["app-config"].ui.mapMarker;

  state = {
    branches: [],
    bounds: [],
    dataLoaded: false,
    mapLanguage: this.defaultLanguage,
    locationAllowed: false,
    allowedLocation: null,
    lang: {},
  };

  constructor(props) {
    super();
    this.mapZoom = parseInt(window["app-config"].mapZoom);
    this.getCurrentLatLong();
  }

  locationServiceDisabled = "";
  OkText = "";
  Attention = "";
  makeAnAppointment = "";
  cancel = "";
  staticHeading = "";
  issueTicket = "";

  Address = "";

  containerStyle = {
    position: "relative",
    width: "100%",
    height: "80%",
  };

  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
    this.getAllBranches();
    this.setMapLanguage();
  }

  onInfoWindowClose = () => {};

  getAllBranches = async () => {
    try {
      let response = await this.dataService.getAllBranches();

      if (response.data.error !== undefined && response.data.error === true) {
        this.setState({ branches: undefined, bounds: [], dataLoaded: true });
      } else if (response.data.branchList === null) {
        this.setState({ branches: [], bounds: [], dataLoaded: true });
      } else {
        var points = [];

        for (let i = 0; i < response.data.branchList.length; i++) {
          points.push({
            lat: parseFloat(response.data.branchList[i].Latitude),
            lng: parseFloat(response.data.branchList[i].Longitude),
          });
        }
        var bounds = new this.props.google.maps.LatLngBounds();
        for (var i = 0; i < points.length; i++) {
          bounds.extend(points[i]);
        }
        this.setState({
          branches: response.data.branchList,
          dataLoaded: true,
          bounds: bounds,
          allowedLocation: JSON.parse(localStorage.getItem("location")),
        });
      }
    } catch (error) {
      console.log("Error: ", error.message);
      if (error.message.includes("timeout")) {
        this.setState({ branches: undefined, dataLoaded: true });
      } else {
        this.setState({ branches: [], dataLoaded: true });
      }
    }
  };

  showLocationAlert = async () => {
    let resp = await swalAlert(
      this.state.lang.Attention,
      this.state.lang.LocationServiceDisabled,
      "warning",
      {
        buttons: {
          ok: {
            text: "Ok",
            value: "ok",
          },
        },
      }
    );
    return resp;
  };

  setMapLanguage = () => {
    if (localStorage.getItem("lang") === "es") {
      this.setState({ mapLanguage: "es" });
    } else if (localStorage.getItem("lang") === "ar") {
      this.setState({ mapLanguage: "ar" });
    } else if (localStorage.getItem("lang") === "en") {
      this.setState({ mapLanguage: "en" });
    } else if (localStorage.getItem("lang") === "ur") {
      this.setState({ mapLanguage: "ur" });
    } else {
      this.setState({ mapLanguage: this.defaultLanguage });
    }
  };

  getCurrentLatLong = () => {
    let currContext = this;
    var defaultLat = this.mapCenter.lat;
    var defaultLng = this.mapCenter.lng;

    var browser = Bowser.getParser(window.navigator.userAgent);

    if (
      browser.getBrowserName() !== "Safari" &&
      queryStringBranchCode === undefined
    ) {
      navigator.geolocation.getCurrentPosition((pos) => {
        let location = {
          lat:
            pos.coords.latitude === null || pos.coords.latitude === undefined
              ? this.mapCenter.lat
              : pos.coords.latitude,
          lng:
            pos.coords.longitude === null || pos.coords.longitude === undefined
              ? this.mapCenter.lng
              : pos.coords.longitude,
        };
        this.setState({ locationAllowed: true, allowedLocation: location });
        localStorage.setItem("location", JSON.stringify(location));
      });
      navigator.geolocation.watchPosition(
        function (position) {},
        function (error) {
          let location = {
            lat: defaultLat,
            lng: defaultLng,
          };

          if (error.code == error.PERMISSION_DENIED) {
            currContext.setState({
              locationAllowed: false,
              allowedLocation: location,
            });
            localStorage.setItem("location", JSON.stringify(location));
            navigator.geolocation.clearWatch((p) => {});
          }
        }
      );
      navigator.permissions
        .query({ name: "geolocation" })
        .then(async (status) => {
          status.onchange = function () {
            if (this.state === "granted") {
              window.location.href = window.location.href;
            } else if (this.state === "denied") {
              let location = {
                lat: defaultLat,
                lng: defaultLng,
              };
              let lang;
              if (localStorage.getItem("lang") === "es") {
                lang = window["localization"].es;
              } else if (localStorage.getItem("lang") === "ar") {
                lang = window["localization"].ar;
              } else if (localStorage.getItem("lang") === "en") {
                lang = window["localization"].en;
              } else if (localStorage.getItem("lang") === "ur") {
                lang = window["localization"].ur;
              } else {
                let defaultLang = this.defaultLanguage;
                lang = window["localization"][defaultLang];
              }
              swal({
                title: lang.Attention,
                text: lang.LocationServiceDisabled,

                icon: "info",
                buttons: {
                  ok: {
                    text: lang.Ok,
                    value: "OK",
                  },
                },
              }).then(() => {
                localStorage.setItem("location", JSON.stringify(location));
                window.location.href = window.location.href;
              });
            }
            console.log(
              "geolocation permission state has changed to ",
              this.state
            );
          };
        });
    } else {
      let location = {
        lat: defaultLat,
        lng: defaultLng,
      };
      localStorage.setItem("location", JSON.stringify(location));
    }
  };

  onMarkerClick = (branch) => {
    console.log("lat: ", branch.Latitude + " lng :" + branch.Longitude);
    console.log("BRANCH: ", branch);
    if (
      this.issueTicketEnabled === true &&
      this.issueAppointmentEnabled === true
    ) {
      swal(
        <div>
          <h3 style={{ color: "#000" }}>{branch.BranchTitle}</h3>
          <strong style={{ color: "#000" }}>{this.state.lang.Address}</strong>
          <p style={{ color: "#000" }}>{branch.Address}</p>
        </div>,

        {
          icon: "info",
          buttons: {
            yes: {
              text: this.state.lang.MakeAnAppointment,
              value: "Yes",
              className: "alert-btn",
            },
            issueTicket: {
              text: this.state.lang.IssueTicket,
              value: "IssueTicket",
              className: "alert-btn",
            },
          },
        }
      ).then((value) => {
        switch (value) {
          case "Yes":
            this.props.setSelectedBranch(branch);
            this.props.getStepCount(1, true, false);
            break;

          case "IssueTicket":
            this.props.setSelectedBranch(branch);
            this.props.getStepCount(
              this.enableCategorySelection === false ? 2 : 1,
              true,
              true
            );
            break;
          default:
        }
      });
    } else if (
      this.issueTicketEnabled === true &&
      this.issueAppointmentEnabled === false
    ) {
      swal(
        <div>
          <h3 style={{ color: "#000" }}>{branch.BranchTitle}</h3>
          <strong style={{ color: "#000" }}>{this.state.lang.Address}</strong>
          <p style={{ color: "#000" }}>{branch.Address}</p>
        </div>,

        {
          icon: "info",
          buttons: {
            yes: {
              text: this.state.lang.IssueTicket,
              value: "issueTicket",
            },
            no: {
              text: this.cancel,
              value: "No",
            },
          },
        }
      ).then((value) => {
        switch (value) {
          case "issueTicket":
            this.props.setSelectedBranch(branch);
            this.props.getStepCount(
              this.enableCategorySelection === false ? 2 : 1,
              true,
              true
            );
            break;

          case "No":
            break;
          default:
        }
      });
    } else if (
      this.issueTicketEnabled === false &&
      this.issueAppointmentEnabled === true
    ) {
      swal(
        <div>
          <h3 style={{ color: "#000" }}>{branch.BranchTitle}</h3>
          <strong style={{ color: "#000" }}>{this.state.lang.Address}</strong>
          <p style={{ color: "#000" }}>{branch.Address}</p>
        </div>,

        {
          icon: "info",
          buttons: {
            yes: {
              text: this.state.lang.MakeAnAppointment,
              value: "Yes",
            },
            no: {
              text: this.cancel,
              value: "No",
            },
          },
        }
      ).then((value) => {
        switch (value) {
          case "Yes":
            this.props.setSelectedBranch(branch);
            this.props.getStepCount(1, true, false);
            break;

          case "No":
            break;
          default:
        }
      });
    }
  };

  render() {
    if (this.state.branches === undefined) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <Empty description={this.state.lang.ServerNotResponding} />
            </div>
          </div>
        </div>
      );
    } else if (this.state.allowedLocation === null) {
      return <Loader />;
    } else if (this.state.dataLoaded === true) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <h2 style={{ color: this.color.fontColor }}>
                {this.state.lang.BranchMapHeading}
              </h2>
              <div style={{ height: "65vh", width: "100%" }}>
                <Map
                  google={this.props.google}
                  zoom={this.mapZoom}
                  style={this.containerStyle}
                  initialCenter={this.state.allowedLocation}
                  center={this.state.allowedLocation}
                  bounds={this.state.bounds}
                >
                  {this.state.branches.length > 0 ? (
                    this.state.branches.map((branch, i) => {
                      return (
                        <Marker
                          onClick={() => {
                            this.onMarkerClick(branch);
                          }}
                          title={branch.BranchTitle}
                          key={i}
                          position={{
                            lat: branch.Latitude,
                            lng: branch.Longitude,
                          }}
                          icon={{
                            url:
                              process.env.PUBLIC_URL +
                              `/images/${this.pinMarker.fileName}`,
                            // anchor: new window.google.maps.Point(0, 0),
                            scaledSize: new window.google.maps.Size(34, 34),
                          }}
                        />
                      );
                    })
                  ) : (
                    <span></span>
                  )}
                  {/* 
        <InfoWindow onClose={this.onInfoWindowClose}>
          <div>
            <h1>Demo Place</h1>
          </div>
        </InfoWindow> */}
                </Map>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.branches === null) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <Empty />
            </div>
          </div>
        </div>
      );
    } else {
      return <Loader />;
    }
  }
}

// export default BranchSelection;
export default GoogleApiWrapper({
  apiKey: "AIzaSyA85oYpaPSkYFRM8d4QcWMg4ZmH8Frnf8c",
  language: localStorage.getItem("lang"),
  LoadingContainer: Loading,
})(BranchSelection);
